import {
  Component,
  OnInit,
  OnChanges,
  AfterViewInit,
  Input,
  ElementRef,
  HostListener,
  ViewChildren,
  QueryList,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { ProfileService } from '../../shared/profile.service';
import { ProfileViewRecentContactsSearch } from './recent-contacts-search.model';
import { PagedResult } from './../../../shared/model/generic-paged-result.model';
import { Contact } from '../../../contacts/shared/contact.model';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { Subscription } from 'rxjs';
import { ProfileContactEditComponent } from '../../profile-contacts';
import { NotificationService } from '../../../shared';
import { UserService } from 'src/app/users/shared/user.service';
import { SecurityAccessLevelEnum } from 'src/app/shared/auth/enum/security-access-level.enum';

@Component({
  selector: 'wl-profile-view-recent-contacts',
  templateUrl: './recent-contacts.component.html',
  styleUrls: ['./recent-contacts.component.css'],
    standalone: false
})
export class ProfileViewRecentContactsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  public constructor(
    profileService: ProfileService,
    observationService: ObservationService,
    private ref: ElementRef,
    private _notificationService: NotificationService,
    private _userService: UserService
  ) {
    this._profileService = profileService;
    this._observationService = observationService;
    this.contacts = new PagedResult<Array<Contact>>();
  }
  private _profileService: ProfileService;
  private _observationService: ObservationService;
  private _profileSubscription: Subscription;
  private _charLimit: number;

  public contacts: PagedResult<Array<Contact>>;
  profileModuleFullAccess: boolean = false;
  profileContactsTabFullAccess: boolean = false;

  @Input() public profileId: number;
  @ViewChildren('contactDescr') contactDescrContainers: QueryList<ElementRef>;
  @ViewChild(ProfileContactEditComponent) contactEdit: ProfileContactEditComponent;
  @HostListener('window:resize', ['$event']) onResize() {
    this.lineClamp();
  }

  ngOnInit() {
    this._charLimit = 0;

    this._profileSubscription = this._observationService.observeProfiles().subscribe((id) => {
      this.profileUpdated(id);
    });

    this.loadContacts(1, true);

    this._userService.getCurrentUserSecurityElementAccessLevel('Profiles_Module').then((userAccessLevel: number) => {
      this.profileModuleFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;

      if (this.profileModuleFullAccess) {
        this._userService.getCurrentUserSecurityElementAccessLevel('ProfileContacts_Tab').then((userAccessLevel: number) => {
          this.profileContactsTabFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;
        });
      }
    });
  }

  ngOnChanges() {
    this._charLimit = 0;
    this.loadContacts(1, true);
  }

  ngAfterViewInit() {
    this.lineClamp();
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  private profileUpdated(id: number) {
    if (id === this.profileId) {
      this.loadContacts(1, true, true);
    }
  }

  public onPagingEvent(page: number) {
    this.loadContacts(page, false);
  }

  private loadContacts(page: number, isInitialLoad: boolean, forceRefresh?: boolean) {
    const search = new ProfileViewRecentContactsSearch();
    search.PageNumber = page;
    search.ProfileId = this.profileId;
    search.PageSize = 5;

    this._profileService.getProfileRecentContacts(search, forceRefresh).then((data: PagedResult<Array<Contact>>) => {
      this.contacts = data;
      this.contacts.CurrentPageNumber = search.PageNumber;

      const element = this.ref.nativeElement;

      if (!isInitialLoad) {
        window.scrollTo(window.scrollX, element.offsetTop + 50);
      }
    });
  }

  private lineClamp() {
    if (this.contactDescrContainers.toArray().length > 0) {
      const element = this.contactDescrContainers.toArray()[0].nativeElement;

      // using 78% to roughly account for character widths
      this._charLimit = element.getBoundingClientRect().width * 0.78;

      for (const contact of this.contacts.Result) {
        if (contact.Descr.length >= this._charLimit) {
          (contact as any).trimmedDescr = contact.Descr.slice(0, this._charLimit - 3) + '...';
        } else {
          (contact as any).trimmedDescr = contact.Descr;
        }
      }
    }
  }

  public addAContactClick() {
    this.contactEdit.profileContact = { ProfileId: this.profileId, ContactDate: new Date() } as any;
    this.contactEdit.open();
  }

  public contactSubmitClicked(contact: Contact) {
    this._profileService.CreateProfileContact(contact).then(
      () => {
        this.contactEdit.close();
        this.loadContacts(1, true);
      },
      (error) => {
        this._notificationService.httpError(error);
      }
    );
  }
}
